"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterNotification = exports.ImageView = exports.SearchBar = exports.SearchBarContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.SearchBarContainer = native_1.default.View `
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  height: 56px;
  padding-right: 16px;
  background-color: ${(p) => p.theme.color.white}
  border: 1px solid ${(props) => props.theme.searchBar.color};
  shadow-color: ${(p) => p.theme.shadow.default.color};
  shadow-offset: 0 1px;
  shadow-opacity: ${(p) => p.theme.shadow.default.opacity};
  shadow-radius: 2px;
  elevation: ${(p) => p.theme.shadow.default.elevation};
`;
exports.SearchBar = native_1.default.TextInput `
  background-color: ${(props) => props.theme.background.primary};
  color: black;
  padding-left: 10px;
  margin-left: 10px;
  font-size: 16px;
  border-radius: 10px;
  flex: 1;
`;
exports.ImageView = native_1.default.TouchableOpacity `
  margin: 0 6px 0 16px;
  align-items: center;
  height: 56px;
  justify-content: center;
`;
exports.FilterNotification = native_1.default.View `
  position: absolute;
  top: 12px;
  right: 5px;
`;
